import { toggleMenu } from "./header";
import { scrollToHash, getSamePageAnchor } from "./smooth-scrolling";
import "../css/main.css";

document.addEventListener("DOMContentLoaded", () => {
  /**
   * Toggle del header
   */

  toggleMenu();

  /**
   * Example carousel import
   */
  const carousel = document.querySelectorAll(".carousel");
  if (carousel.length > 0) {
    import("./carousel").then((module) => {
      carousel.forEach((slider) => {
        module.carousel(slider);
      });
    });
  }

  const carouselReviews = document.querySelectorAll(".carousel-reviews");
  if (carouselReviews.length > 0) {
    import("./carousel").then((module) => {
      carouselReviews.forEach((slider) => {
        module.carouselReviews(slider);
      });
    });
  }

  /**
   * Smooth scrolling support
   */
  // If a link's href is within the current page, scroll to it instead
  document.querySelectorAll("a[href]").forEach((a) => {
    a.addEventListener("click", (e) => {
      scrollToHash(getSamePageAnchor(a), e);
    });
  });
  // Scroll to the element in the URL's hash on load
  scrollToHash(window.location.hash);

  /**
   * ACF7 event listener
   */
  document.addEventListener(
    "wpcf7mailsent",
    (event) => {
      gtag("event", "Formulario", {
        event_category: event.detail.contactFormId,
        event_label: event.detail.unitTag,
      });
    },
    false,
  );

  const videoContainers = document.querySelectorAll("[data-autoplay-video]");
  if (videoContainers.length > 0) {
    videoContainers.forEach((container) => {
      const video = container.querySelector("video");
      if (video) {
        video.setAttribute("playsinline", "true");
      }
    });
  }

  document.addEventListener(
    "wpcf7mailsent",
    function (event) {
      // Reemplaza el '123' por el ID de tu formulario de Contact Form 7
      if (5 == event.detail.contactFormId) {
        // Reemplaza la URL por la página a la que quieres redirigir
        location = "https://www.francescococina.com/gracias/";
      }
    },
    false,
  );
});
